import PropTypes from 'prop-types';
import EquipmentField from './EquipmentField';
import Section from './Section';
import { INVENTORY_STATUS_LABEL } from 'utils/constants';

const EquipmentDetails = ({ equipmentCategory, vinNumber, licencePlate, equipmentStatus, company, searchTerm }) => {
    if (!equipmentCategory && !vinNumber && !licencePlate && !equipmentStatus && !company) return null;

    return (
        <Section label="EQUIP">
            {equipmentCategory?.name && <EquipmentField label="Category" value={equipmentCategory.name} searchTerm={searchTerm} />}
            {vinNumber && <EquipmentField label="VIN #" value={vinNumber} searchTerm={searchTerm} />}
            {licencePlate && <EquipmentField label="License Plate" value={licencePlate} searchTerm={searchTerm} />}
            {equipmentStatus && <EquipmentField label="Status" value={INVENTORY_STATUS_LABEL[equipmentStatus]} searchTerm={searchTerm} />}
            {company?.name && <EquipmentField label="Company" value={company.name} searchTerm={searchTerm} />}
        </Section>
    );
};

EquipmentDetails.propTypes = {
    equipmentCategory: PropTypes.shape({
        name: PropTypes.string,
    }),
    vinNumber: PropTypes.string,
    licencePlate: PropTypes.string,
    equipmentStatus: PropTypes.string,
    company: PropTypes.shape({
        name: PropTypes.string,
    }),
    searchTerm: PropTypes.string,
};

export default EquipmentDetails;
